module.exports = __webpack_public_path__ + "static/media/3.0b36ff2d.png";